/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import Vue from "vue";
import baseURL from "@/api/http-common";

let userObj =
  localStorage.getItem("telasUserObj") !== null &&
  localStorage.getItem("telasUserObj").length > 0
    ? JSON.parse(localStorage.getItem("telasUserObj"))
    : "";

const frameworkState = {
  frameworks: {},
  frameworkDetails: {},
  frameworkQuestions: {},
};

const getters = {
  // Add any getters here if needed
  allFrameworks: (state) => state.frameworks,
  frameworkDetails: (state) => state.frameworkDetails,
  frameworkQuestions: (state) => state.frameworkQuestions,
};

const actions = {
  async fetchFrameworks({ commit, rootState }) {
    commit("LOADING", { rootState });
    try {
      const response = await Vue.axios.get(
        `${baseURL}wp/v2/telas_framework/?_fields=id,title`,
        {
          headers: {},
        }
      );
      const frameworks = response.data;
      commit("SETFRAMEWORKS", { frameworks });
    } catch (error) {
      commit("HANDLEERROR", { error, rootState });
    }
    commit("ENDLOADING", { rootState });
  },
  async fetchFrameworkById({ commit, rootState }, frameworkId) {
    commit("LOADING", { rootState });
    try {
      const response = await Vue.axios.get(
        `${baseURL}wp/v2/telas_framework/${frameworkId}`,
        {
          headers: {},
        }
      );
      const frameworkDetails = response.data;
      commit("SETFRAMEWORKDETAILS", { frameworkDetails });
    } catch (error) {
      commit("HANDLEERROR", { error, rootState });
    }
    commit("ENDLOADING", { rootState });
  },
  async fetchFrameworkQuestions({ commit }, frameworkId) {
    try {
      const response = await Vue.axios.get(
        `${baseURL}extended-telasweb/v1/framework-questions`,
        {
          params: { frameworkId: frameworkId }, // Ensure this matches how your API expects to receive the frameworkId
        }
      );
      commit("SET_FRAMEWORK_QUESTIONS", response.data); // Commit the fetched questions to the state
    } catch (error) {
      console.error("Error fetching framework questions:", error);
      // Handle the error appropriately
    }
  },
  async updateFrameworkQuestions({ commit, rootState }, data) {
    commit("LOADING", { rootState });
    try {
      userObj =
        rootState.user.userDetails.length > 0
          ? rootState.user.userDetails
          : userObj;
      const { userToken } = data;
      const { frameworkId } = data;
      const options = {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
        params: {
          frameworkId: frameworkId,
        }, // Ensure this matches how your API expects to receive the frameworkId
      };
      const response = await Vue.axios.post(
        `${baseURL}extended-telasweb/v1/framework-questions`,
        data,
        options
      );
      const actualData = response.data;
      commit("SET_FRAMEWORK_QUESTIONS", { actualData });
    } catch (error) {
      console.log(error);
    }
    commit("ENDLOADING", { rootState });
  },
  async createFramework({ commit, rootState }, frameworkData) {
    commit("LOADING", { rootState });
    try {
      const response = await Vue.axios.post(
        `${baseURL}wp/v2/telas_framework`,
        frameworkData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${frameworkData.userToken}`,
          },
        }
      );
      const newFramework = response.data;
      commit("ADDFRAMEWORK", { newFramework });
    } catch (error) {
      commit("HANDLEERROR", { error, rootState });
    }
    commit("ENDLOADING", { rootState });
  },
  async updateFramework({ commit, rootState }, { frameworkId, frameworkData }) {
    commit("LOADING", { rootState });
    try {
      const response = await Vue.axios.post(
        `${baseURL}wp/v2/telas_framework/${frameworkId}`,
        frameworkData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${frameworkData.userToken}`,
          },
        }
      );
      const updatedFramework = response.data;
      commit("UPDATEFRAMEWORK", { frameworkId, updatedFramework });
    } catch (error) {
      commit("HANDLEERROR", { error, rootState });
    }
    commit("ENDLOADING", { rootState });
  },
  async deleteFramework({ commit, rootState }, { frameworkId, userToken }) {
    commit("LOADING", { rootState });
    try {
      await Vue.axios.delete(
        `${baseURL}wp/v2/telas_framework/${frameworkId}?force=true`,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        }
      );
      commit("REMOVEFRAMEWORK", { frameworkId });
    } catch (error) {
      commit("HANDLEERROR", { error, rootState });
    }
    commit("ENDLOADING", { rootState });
  },
};

const mutations = {
  UPDATEFRAMEWORKQUESTIONS(state, { actualData }) {
    const { tabIndex } = actualData;
    const { currentStep } = actualData;
    const { steps } = actualData;
    const { updating } = actualData;
    const { questionIndex } = actualData;
    const { headingText } = actualData;
    const { questionText } = actualData;
    const { adminOnly } = actualData;
    const { newHeadingQuestion } = actualData;
    const { newQuestion } = actualData;
    const { domainScoreKey } = actualData;
    const { domainScoreValue } = actualData;
    const { newDomainValue } = actualData;
    const { subTitleText } = actualData;
    switch (updating) {
      case "editSubTitle":
        Vue.set(steps[currentStep], "subTitle", subTitleText);
        Vue.set(steps[currentStep], "editing", false);
        break;
      case "editSubtitleTrigger":
        Vue.set(steps[currentStep], "editing", true);
        break;
      case "editHeading":
        Vue.set(steps[currentStep].content[tabIndex], "heading", headingText);
        Vue.set(steps[currentStep].content[tabIndex], "editing", false);
        break;
      case "editHeadingTrigger":
        Vue.set(steps[currentStep].content[tabIndex], "editing", true);
        break;
      case "editQuestionTrigger":
        Vue.set(
          steps[currentStep].content[tabIndex].questions[questionIndex],
          "editing",
          true
        );
        break;
      case "editQuestion":
        Vue.set(
          steps[currentStep].content[tabIndex].questions[questionIndex],
          "question",
          questionText
        );
        Vue.set(
          steps[currentStep].content[tabIndex].questions[questionIndex],
          "editing",
          false
        );
        break;
      case "editAdminOnly":
        Vue.set(
          steps[currentStep].content[tabIndex].questions[questionIndex],
          "adminOnly",
          adminOnly
        );
        break;
      case "deleteHeading":
        steps[currentStep].content.splice(tabIndex, 1);
        break;
      case "deleteQuestion":
        steps[currentStep].content[tabIndex].questions.splice(questionIndex, 1);
        break;
      case "addHeadingQuestion":
        const newHeadingObj = {
          adminOnly: false,
          domainScore: {
            0: "Yes",
            1: "Yes But",
            2: "No But",
            3: "No",
          },
          heading: newHeadingQuestion,
          questions: [],
        };
        steps[currentStep].content.push(newHeadingObj);
        break;
      case "addQuestion":
        const newQuestionObj = {
          adminOnly: false,
          options: ["Yes", "Yes But", "No But", "No"],
          question: newQuestion,
        };
        steps[currentStep].content[tabIndex].questions.push(newQuestionObj);
        break;
      case "updateDomain":
        delete steps[currentStep].content[tabIndex].domainScore[domainScoreKey];
        Vue.set(
          steps[currentStep].content[tabIndex].domainScore,
          newDomainValue,
          domainScoreValue
        );
        // steps[currentStep].content[tabIndex].domainScore[newDomainValue] = domainScoreValue;
        break;
      default:
        break;
    }
  },

  SET_FRAMEWORK_QUESTIONS(state, questions) {
    state.frameworkQuestions = questions;
  },
  SETFRAMEWORKS(state, { frameworks }) {
    state.frameworks = frameworks;
  },
  SETFRAMEWORKDETAILS(state, { frameworkDetails }) {
    state.frameworkDetails = frameworkDetails;
  },
  ADDFRAMEWORK(state, { newFramework }) {
    state.frameworks.push(newFramework);
  },
  UPDATEFRAMEWORK(state, { frameworkId, updatedFramework }) {
    const index = state.frameworks.findIndex((f) => f.id === frameworkId);
    if (index !== -1) {
      Vue.set(state.frameworks, index, updatedFramework);
    }
  },
  REMOVEFRAMEWORK(state, { frameworkId }) {
    state.frameworks = state.frameworks.filter((f) => f.id !== frameworkId);
  },
  HANDLEERROR(state, { error, rootState }) {
    console.error("Error:", error);
    // Handle error state updates here
  },
  LOADING(state, { rootState }) {
    rootState.common.loading = true;
  },
  ENDLOADING(state, { rootState }) {
    rootState.common.loading = false;
  },
};

export default {
  namespaced: true,
  state: frameworkState,
  getters,
  actions,
  mutations,
};
